import { withTheme, keyframes, css } from '@emotion/react';
import styled from '@emotion/styled';
import { useInView } from 'react-intersection-observer';
import Button from '../components/shared/Button';
import frillRight from '../assets/images/stats-frill_right.svg';

const popIn = keyframes`
0% {
  opacity: 0;
  transform: scale(0) rotate(-45deg);
}
100% {
  opacity: 1;
  transform: scale(1) rotate(-45deg);
}
`;

const BlockContainer = styled.div`
  background: ${props => props.theme.colors.neutral2};
  border-radius: 12px;
  margin-top: 80px;
  padding: ${props => props.theme.margins.xs};
  position: relative;
  width: 100%;

  @media (min-width: ${props => props.theme.breakpoints.lg}) {
    max-width: 800px;
  }
`;

const StyledP = styled.p`
  color: ${props => props.theme.colors.neutral1};
  font-family: ${props => props.theme.fonts.secondary};
  margin: 24px 0;
  max-width: ${props => props.theme.breakpoints.md};
  text-align: left;
  width: 100%;

  span {
    display: inline-block;
    line-height: ${props => props.theme.lineHeights.sm};
    margin-bottom: ${props => props.theme.margins.xxxs};
  }
`;

const HeaderBubble = styled.div`
  background-color: ${props => props.theme.colors.contrast2};
  border: 3px solid ${props => props.theme.colors.primary4};
  border-radius: 6px;
  color: ${props => props.theme.colors.primary4};
  font-family: ${props => props.theme.fonts.primary};
  font-size: ${props => props.theme.fontSizes.md};
  font-weight: bold;
  left: 0;
  padding: 12px;
  position: absolute;
  top: -70px;
  width: 200px;

  &:before {
    background-color: ${props => props.theme.colors.contrast2};
    border-color: ${props => props.theme.colors.primary4};
    border-style: solid;
    border-width: 0 3px 3px 0;
    bottom: -10px;
    content: "";
    display: block;
    height: 12px;
    position: absolute;
    transform: rotate(45deg);
    width: 12px;
  }

  @media (min-width: ${props => props.theme.breakpoints.md}) {
    left: 20px;
  }
`;

const Ani = styled.span`
  ${props => props.inView && css`
    animation: .5s ${popIn} ease;
    animation-fill-mode: forwards;
  `}
  background-image: url(${frillRight});
  content: "";
  display: block;
  height: 77px;
  opacity: 0;
  position: absolute;
  right: -40px;
  top: -40px;
  width: 58px;
  background-size: contain;
  transform: rotate(-45deg);
`;

const StyledButton = styled(Button)`
  align-self: center;
  display: flex;
  justify-content: center;
  margin: 0 auto;
`; 

function renderCopyText(copy) {
  return copy.map((text, i) => {
    return <span key={`info-cta-copy-${i}`}>{text}</span>
  })
}

function InfoCTA(props) {
  const { header, copy, buttonText } = props.data;
  const { ref, inView } = useInView({
    threshold: .1,
  });

  function handleClick() {
    window.scrollTo(0, 0);
  }

  return (
    <BlockContainer ref={ref}>
      <HeaderBubble>
        {header}
        <Ani inView={inView} />
      </HeaderBubble>
      <StyledP>
        {renderCopyText(copy)} 
      </StyledP>
      <StyledButton text={buttonText} handleClick={handleClick} />
    </BlockContainer>
  );
}

export default withTheme(InfoCTA);